export const VAT_RATE_NL = 0.21;
export const ENERGY_TAX_RATE_BEFORE_2026 = 0.10154;
export const ENERGY_TAX_RATE_FROM_2026 = 0.09161157;
export const ENERGY_TAX_RATE_CHANGE_DATE = new Date(Date.UTC(2026, 0, 1));

export const getNlEnergyTaxRate = (date: Date = new Date()): number =>
  date >= ENERGY_TAX_RATE_CHANGE_DATE
    ? ENERGY_TAX_RATE_FROM_2026
    : ENERGY_TAX_RATE_BEFORE_2026;
